define('responsive-gameday/views/Monitor/ViewModels/InningPlaysViewModel',['require','exports','module','./ViewModelBase','GameDayCore','../Events/ViewModelUpdateEvents','gameday-resource-path/gameday-resource-path','message-service/message-service','extant/extant'],function(require,exports,module) {
    var ViewModelBase = require("./ViewModelBase"),
        GDC = require("GameDayCore"),
        UpdateEvents = require("../Events/ViewModelUpdateEvents"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        MessageService = require( "message-service/message-service" ),
        // ScoringPlaysDistributor = require( "../../distributors/ScoringPlaysDistributor" ),
        exists = require("extant/extant"),
        Superclass;

    function InningPlaysViewModel() {
        Superclass.constructor.call(this);
        // MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
        MessageService.addListener.call(this, UpdateEvents.REQUEST_INNING_DATA, this.handleUpdateRequest);
    }

    ViewModelBase.spawn(InningPlaysViewModel).define({
        moldData: function(flavor) {
            var dataPack = {};

            dataPack.game = this.gameData.game || {};
            dataPack.linescore = this.gameData.linescore || {};
            dataPack.currentInning = dataPack.linescore.inning;
            dataPack.players = this.gameData.players || {};
            dataPack.innings = this.gameData.all_innings && this.gameData.all_innings.innings || {};
            dataPack.teams = {
                home: this.gameData.game.home,
                away: this.gameData.game.away
            };

            dataPack.team_code = function (that) {
                return 't' + dataPack.teams[this.home_or_away].id;
            }

            dataPack.pitcher_name = function (that) {
                var pitcher = dataPack.players && dataPack.players.playerMap[this.pitcher];
                return (exists(pitcher)) ? pitcher.first + ' ' + pitcher.last : "";
            }
            dataPack.mugshot = function(){
                return resourcePath.get('mugshot',{ pid : this.batter});
            };

            this.dataPack=dataPack;

            this.dispatchUpdates(UpdateEvents.UPDATE_INNING, dataPack);
        },

        handleUpdateRequest : function(inning){
            var that = this;
            this.gameData = GDC.getGameData();
            if(!inning){
                var linescore = GDC.getGameData().linescore;
                inning = ~~linescore.inning || 0;
            }
            if (exists(this.gameData.all_innings[inning])) {
                that.moldData();
            } else {
               MessageService.one.call(that, GDC.requestGameData('all_innings', {
                        inning: inning
                    }), function(payload, evt) {
                       that.gameData = GDC.getGameData();
                       that.moldData();
                   });
            }

        }
    });

    Superclass = InningPlaysViewModel.superclass;

    return InningPlaysViewModel;
});
